import '../../css/PopMessage.css'

const PopMessageDetailsDiv = (props:{divKey:string, value:string}) => {

    return (
        <div className='asset-details-data' style={{textAlign: "left", display: "flex"}}>
            <div className='asset-details-data-divKey' style={{width: "100px"}}>{`${props.divKey}: `}</div>
            <span className='asset-details-data-value'>{props.value}</span>
        </div>
    );
};

export default PopMessageDetailsDiv;